import t from "./highrise1468.mjs";
import o from "./highrise532.mjs";
import p from "./highrise1469.mjs";
import e from "./highrise643.mjs";
function n(r, a) {
  var m = e(r) ? t : p;
  return m(r, o(a));
}
export {
  n as default
};
